import React from "react";
import ErrorInner from "../components/ErrorInner";

const ErrorPage = () => {
  return (
    <>
      {/* ErrorInner */}
      <ErrorInner />
    </>
  );
};

export default ErrorPage;
